import { render, staticRenderFns } from "./inviteFirend.vue?vue&type=template&id=0ffc4b04&scoped=true"
import script from "./inviteFirend.vue?vue&type=script&lang=js"
export * from "./inviteFirend.vue?vue&type=script&lang=js"
import style0 from "./inviteFirend.vue?vue&type=style&index=0&id=0ffc4b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc4b04",
  null
  
)

export default component.exports